<script setup>
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/modules/user'
/**
 * 修改密码弹窗
 */
import api from '@/api'
import { onClickOutside } from '@vueuse/core'
import CustomInput from '@/components/common/CustomInput/index.vue'
import { useRouter } from 'vue-router'
const router = useRouter()

defineOptions({
  name: 'DialogEditAccountPassword'
})

const oldPassword = ref('')
const newPassword = ref('')
const isSubmitLoading = ref(false)
const userStore = useUserStore()
const keyboardInput = ref('')
const dialogVisible = defineModel()

/**
 * 修改密码
 * @returns {Promise<void>}
 */
async function handleSubmit() {
  try {
    if (!oldPassword.value) {
      ElMessage.error('请输入原密码')
      return
    }
    if (!newPassword.value) {
      ElMessage.error('请输入新密码')
      return
    }
    isSubmitLoading.value = true
    await api.staff.resetMyPassword({
      old_password: oldPassword.value,
      new_password: newPassword.value
    })
    ElMessage.success('修改密码成功，请重新登录')
    isSubmitLoading.value = false
    setTimeout(() => {
      logout()
    }, 500)
  } catch (e) {
    isSubmitLoading.value = false
    console.error('修改密码失败', e)
  }
}
function resetFormData() {
  oldPassword.value = ''
  newPassword.value = ''
}

const isOldPasswordInputFocus = ref(true)
const isNewPasswordInputFocus = ref(false)
function handleOldPasswordInputFocus() {
  isOldPasswordInputFocus.value = true
}
function handleOldPasswordInputBlur() {
  isOldPasswordInputFocus.value = false
}
function handleNewPasswordInputFocus() {
  isNewPasswordInputFocus.value = true
}
function handleNewPasswordInputBlur() {
  isNewPasswordInputFocus.value = false
}

const newPasswordRef = ref(null)
const numberKeyboardRef = ref(null)
const oldPasswordInputRef = ref(null)
const newPasswordInputRef = ref(null)
onClickOutside(
  newPasswordRef,
  (event) => {
    console.log('onClickOutside1')
    oldPasswordInputRef.value.focus()
    newPasswordInputRef.value.blur()
  },
  { ignore: [numberKeyboardRef] }
)
function handleClickNewPassword() {
  oldPasswordInputRef.value.blur()
  newPasswordInputRef.value.focus()
}

/**
 * 自定义键盘的值发生变化
 * @param key
 */
function handleClickKeyboard(key) {
  if (isOldPasswordInputFocus.value) {
    if (key === 'clear') {
      oldPassword.value = ''
      return
    }
    if (key === 'back') {
      oldPassword.value = oldPassword.value.slice(0, -1)
      return
    }
    oldPassword.value += key
  }
  if (isNewPasswordInputFocus.value) {
    if (key === 'clear') {
      newPassword.value = ''
      return
    }
    if (key === 'back') {
      newPassword.value = newPassword.value.slice(0, -1)
      return
    }
    newPassword.value += key
  }
}

/**
 * 退出登录
 */
function logout() {
  userStore.logout()
  router.replace('/login')
}
</script>

<template>
  <el-dialog
    v-model="dialogVisible"
    :append-to-body="true"
    title="修改密码"
    width="610px"
    @close="resetFormData"
  >
    <div class="dialog-edit-account-password-panel">
      <div class="form-container">
        <div class="form-item">
          <div class="aic mr-20">
            <icon icon-class="el-icon-lock" />
            <span class="ml-5">原密码</span>
          </div>
          <custom-input
            ref="oldPasswordInputRef"
            v-model="oldPassword"
            :show-keyboard="false"
            :auto-focus="true"
            :auto-blur="false"
            type="password"
            placeholder="请输入原密码"
            @focus="handleOldPasswordInputFocus"
            @blur="handleOldPasswordInputBlur"
          ></custom-input>
        </div>

        <div ref="newPasswordRef" class="form-item mt-30" @click="handleClickNewPassword">
          <div class="aic mr-20">
            <icon icon-class="el-icon-lock" />
            <span class="ml-5">新密码</span>
          </div>
          <custom-input
            ref="newPasswordInputRef"
            v-model="newPassword"
            :show-keyboard="false"
            :auto-blur="false"
            type="password"
            placeholder="请输入新密码"
            @focus="handleNewPasswordInputFocus"
            @blur="handleNewPasswordInputBlur"
          ></custom-input>
        </div>
        <el-button
          class="button-submit el-button-primary-gradient"
          :loading="isSubmitLoading"
          type="primary"
          @click="handleSubmit"
          >{{ isSubmitLoading ? '修改中' : '提交修改' }}</el-button
        >
      </div>

      <div ref="numberKeyboardRef" class="number-keyboard-container">
        <number-keyboard v-model="keyboardInput" @click-keyboard="handleClickKeyboard" />
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
.dialog-edit-account-password-panel {
  display: flex;
  justify-content: space-between;

  .form-container {
    padding: 8px 0;
    .form-item {
      display: flex;
      align-items: center;
      padding: 10px 10px;
      border-radius: $radius;
      background-color: rgba(255, 255, 255, 0.2);

      :deep(.custom-input) {
        background-color: transparent;
      }
    }

    .button-submit {
      width: 100%;
      display: flex;
      align-items: center;
      height: 42px;
      margin-top: 55px;
    }
  }

  .number-keyboard-container {
    margin-right: -7px;

    .number-keyboard :deep(.key-item) {
      min-width: 56px;
      height: 48px;
      margin: 7px;
      font-size: 18px;
    }
  }
}
</style>
